import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StartPage from './pages/StartPage';
import GamePage from './pages/GamePage';  
import PasswordWall from './pages/PasswordWall'; 
import './App.css';

function App() {
  const [character, setCharacter] = useState(null);
  const [messages, setMessages] = useState([]);
  const [started, setStarted] = useState(false);

  return (
    <Router>
      <Routes>
      <Route path="/" element={<PasswordWall />} />
        <Route
          path="/start"
          element={
            <StartPage
              setCharacter={setCharacter}
              setMessages={setMessages}
              setStarted={setStarted}
            />
          }
        />
        <Route
          path="/game"
          element={
            <GamePage
              character={character}
              messages={messages}
              setMessages={setMessages}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
